import { render, staticRenderFns } from "./TalksComponent.vue?vue&type=template&id=775932b8&"
import script from "./TalksComponent.vue?vue&type=script&lang=js&"
export * from "./TalksComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports